"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.AddBackorderDemandEvent = void 0;
const Name = exports.Name = 'add-backorder-demand';
const AddBackorderDemandEvent = exports.AddBackorderDemandEvent = Name;
//# sourceMappingURL=index.js.map